/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import React from 'react'
import { resultListCss } from '../style'
import { useCalculator } from '../use-calculator'
import { fmt } from '../../twd'

export const PerTransaction = () => {

    const { calcOutput:co } = useCalculator()

    return <React.Fragment>
        <h3>Per transaction ($)</h3>
        <dl css={resultListCss} style={{marginBottom:'0px'}}>
            <dt>Amount</dt>
            <dd>{fmt.money(co.amount)}</dd>
            <dt>Commission</dt>
            <dd>{fmt.money(co.commission)}</dd>
            <dt>Accrued Int</dt>
            <dd>{fmt.money(co.accruedInt)}</dd>
            <dt>Total order</dt>
            <dd>{fmt.money(co.totalOrder)}</dd>
        </dl>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/calculator/calc-output/per-transaction.js